import { Component, h, Prop } from "@stencil/core";

@Component({
    tag: "ux-link",
    styleUrl: "link.scss",
    shadow: true
})
export class Headline {
    /**
     * The href of the link
     */
    @Prop() readonly href!: string;

    /**
     * The target of the link (default is _self)
     */
    @Prop() readonly target: "_self" | "_blank" = "_self";

    /**
     * The variant of the link
     */
    @Prop({ reflect: true }) readonly variant = "primary";

    /**
     * The download attribute of the link
     */
    @Prop({ reflect: true }) readonly download = false;

    render(): JSX.Element {
        return (
            <a href={this.href} target={this.target}>
                <slot />
            </a>
        );
    }
}
